import { useSeo } from "@/lib/seo";
import { IMAGES } from "@/data/site";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";

const CAPABILITIES = [
  "Land acquisition", "Entitlements", "Utility coordination", "Infrastructure strategy",
  "Residential development", "Industrial redevelopment", "Technology-driven development", "Site control",
];

export default function About() {
  useSeo("About | 12 Stone Development Group LLC",
    "12 Stone Development Group LLC is a privately held development company focused on identifying and advancing strategic real estate and infrastructure opportunities throughout the Southeast.");
  return (
    <div>
      <PageHero overline="About 12 Stone" title="Development Begins With Seeing Opportunity Before Everyone Else"
        subtitle="A privately held development company advancing strategic real estate and infrastructure opportunities throughout the Southeast."
        image={IMAGES.transmission} />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-20">
        <Reveal>
          <p className="text-lg text-foreground/90 leading-relaxed">
            12 Stone Development Group LLC is a privately held development company focused on identifying and advancing
            strategic real estate and infrastructure opportunities throughout the Southeast.
          </p>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            The company works across land acquisition, entitlements, utility coordination, infrastructure strategy,
            residential development, industrial redevelopment and technology-driven development — assembling the pieces
            required for large-scale growth before opportunities become obvious to the broader market.
          </p>
        </Reveal>
      </section>

      <section className="border-t border-border bg-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
          <Reveal><Overline>Capabilities</Overline></Reveal>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {CAPABILITIES.map((c, i) => (
              <Reveal key={c} delay={(i % 4) * 0.05}>
                <div className="rounded-xl border border-border bg-card p-6 h-full">
                  <div className="font-mono text-xs text-primary mb-2">{String(i + 1).padStart(2, "0")}</div>
                  <div className="text-foreground font-medium">{c}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
